import { Component, Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class NotiService {
  constructor(private message: NzMessageService) {}
  success(message?: string) {
    this.message.create('success', message || 'Cập nhật thành công');
  }
  error(message?: string) {
    this.message.create('error', message || 'Có lỗi xảy ra');
  }
  warning(message?: string) {
    this.message.create('warning', message || 'Có lỗi xảy ra');
  }
}
